import { render } from "./wednesday.vue?vue&type=template&id=b6a2a4a6"
import script from "./wednesday.vue?vue&type=script&lang=js"
export * from "./wednesday.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__